import {
  Box,
  Button,
  CardContent,
  Card,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Typography,
  Stepper,
  StepLabel,
  Step,
  Tabs,
  Tab,
  Chip,
  InputAdornment,
  Tooltip,
  IconButton,
} from "@mui/material";
import { useEffect, useState } from "react";
import SelectableSearch from "../../../../Base/views/SelectableSearch";
import { useDispatch, useSelector } from "react-redux";
import FormGroup from "@mui/material/FormGroup";
import { getUserData } from "../../../../Base/helper/baseFunctions";
import Switch from "@mui/material/Switch";
import Quill from "../../../../Base/views/Quill";
import CreatableSearch from "../../../../Base/views/CreatableSearch";
import ArrowBackButton from "../../../../Base/views/ArrowBackButton";
import history from "../../../../../../history";
import { createStyles, makeStyles } from "@mui/styles";
import { CustomTextField } from "../../../../Base/views/CustomComponents";
import { CheckCircle } from "@mui/icons-material";
import VideoQuestionBuilder from "./VideoQuestionBuilderTab";
import PreScreenQuestionBuilder from "./PreScreenQuestionBuilder";
import { AddPreScreenTemplateAction } from "../../../../../../store/ATS/FormTemplate/Action";
import JobReview from "./JobReview";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const CreateJobStepper = ({
  jobPostFormMode,
  jobPostData,
  setPostJobData,
  handleChange,
  errors,
  setErrors,
  validate,
  primaryRecruiterData,
  atsCompanyData,
  atsConsultancyData,
  companyData,
  setCompanyData,
  atsgroupUser,
  setAtsGroupUser,
  consultancyData,
  setConsultancyData,
  jobTitle,
  setJobTitle,
  industrytype,
  feedbackTemplate,
  prescreenTemplate,
  offerTemplate,
  offerstatus,
  skills,
  setSkills,
  rolesresponsibilities,
  setRolesResponsibilities,
  description,
  setDescription,
  handlePrimaryRecruiterLoading,
  handleToggle,
  handleIndustryTypeLoading,
  handleJobTemplateLoading,
  handleFeedBackTemplateLoading,
  handlepreScreenTemplateLoading,
  handleOfferTemplateLoading,
  handleSkillsLoading,
  handleSkillsLoading2,
  setSkills2,
  skills2,
  handleClose,
  toggle,
  isGroupOrgFlowTrue,
  prebuilderTitle,
  setPreBuilderTitle,
  handleSubmit,
  populateDefaultPreScreeningTemplate,
  handleRecruiterManagerLoading,
  recruiterManagerData,
  handleMPROption,
  mprData,
  handleBuload,
  buOption,
  handleApproverList,
  approverListData,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { atsGroupCompanyData } = useSelector(
    (state) => state.AtsReducer?.AtsGroupCompanyReducer,
  );

  const userData = getUserData();

  const handleATSSettings = () => {
    history.push({
      pathname: "/ats/ats-settings/",
      state: { defaultValue: "2" },
    });
  };
  const handleAddHiringPartner = () => {
    history.push({
      pathname: "/ats/manage-consultancy",
      state: { defaultValue: "add" },
    });
  };
  const handleAddClient = () => {
    history.push({
      pathname: "/ats/manage-company",
      state: { defaultValue: "add" },
    });
  };
  const handleAddGrp = () => {
    history.push({
      pathname: "/ats/manage-group-company",
      state: { defaultValue: "add" },
    });
  };

  const [currentStep, setCurrentStep] = useState(0);

  const isAIJob = Boolean(jobPostData?.is_ai_job);
  const steps = isAIJob
    ? [
        "Job Basics",
        "Requirements & Workflow",
        "Job Description",
        "Candidate Screening",
        "Review",
      ]
    : ["Job Basics", "Requirements & Workflow", "Job Description", "Review"];
  // validation based on current step and their fields
  const validateStepFields = (stepIndex) => {
    const stepFields = getStepFields(isAIJob, jobPostData);
    const fieldsToValidate = stepFields[stepIndex] || [];
    let payload = {};
    fieldsToValidate.forEach((field) => {
      payload[field] = jobPostData[field];
    });
    return validate(payload, description, rolesresponsibilities);
  };

  //   step 3 video assesment
  const [step2Tab, setStep2Tab] = useState(0);
  const [videoQuestions, setVideoQuestions] = useState([]);

  const [preScreenQuestions, setPreScreenQuestions] = useState([]);

  const handleSaveNewPreScreenTemplate = () => {
    dispatch(
      AddPreScreenTemplateAction(
        {
          prescreen_template_name: prebuilderTitle,
          prescreen_template_fields: JSON.stringify(preScreenQuestions),
        },
        (error, response) => {
          if (!error && response?.data?.statuscode === 200) {
            const resData = response?.data?.data?.length
              ? response?.data?.data
              : [];
            setPostJobData((prev) => {
              return {
                ...prev,
                prescreen_template_id: resData[resData?.length - 1],
              };
            });
            setPreBuilderTitle("");
            handlepreScreenTemplateLoading("new", resData);
          }
        },
      ),
    );
  };

  const handleNext = () => {
    const isValid = validateStepFields(currentStep);
    if (!isValid) return;
    if (isAIJob && currentStep === 3 && prebuilderTitle) {
      // auto save new PreScreening Template if not saved manually
      if (preScreenQuestions?.length) {
        handleSaveNewPreScreenTemplate();
      } else {
        populateDefaultPreScreeningTemplate();
        setPreBuilderTitle("");
      }
    }
    if (currentStep === steps.length - 1) {
      handleSubmit(true);
      return;
    }
    setCurrentStep((prev) => prev + 1);
  };

  const handleBack = () => {
    if (currentStep === 0) return;
    setCurrentStep((prev) => prev - 1);
  };

  useEffect(() => {
    setPreScreenQuestions(
      jobPostData?.prescreen_template_id?.prescreen_template_fields || [],
    );
  }, [jobPostData?.prescreen_template_id]);

  useEffect(() => {
    setPostJobData((prev) => ({
      ...prev,
      prescreen_template_json: preScreenQuestions,
      prescreen_random_freq: {
        ...prev.prescreen_random_freq,
        prequestion_random_freq: preScreenQuestions?.length,
      }
    }));
    // eslint-disable-next-line
  }, [preScreenQuestions]);
  useEffect(() => {
    setPostJobData((prev) => ({
      ...prev,
      video_prescreen_template_json: videoQuestions,
      prescreen_random_freq: {
        ...prev.prescreen_random_freq,
        video_random_freq: videoQuestions?.length
      }
    }));
    // eslint-disable-next-line
  }, [videoQuestions]);

  const renderStepContent = () => {
    if (!isAIJob && currentStep === 3) {
      return (
        <Card elevation={0} sx={{ border: "2px solid #e0e0e0", mt: 1 }}>
          <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
            <JobReview
              jobPostData={jobPostData}
              description={description}
              rolesresponsibilities={rolesresponsibilities}
              videoQuestions={videoQuestions}
              preScreenQuestions={preScreenQuestions}
              toggle={toggle}
              isGroupOrgFlowTrue={isGroupOrgFlowTrue}
            />
          </CardContent>
        </Card>
      );
    }
    switch (currentStep) {
      case 0:
        return (
          <>
            {jobPostFormMode !== "Preview" && (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {["Admin", "Owner", "Internal"].includes(
                    userData?.user_type,
                  ) && (
                    <>
                      <div style={{ display: "flex" }}>
                        {userData?.user_type !== "Internal" && (
                          <>
                            <div
                              style={{ display: "flex", marginRight: "8px" }}
                            >
                              <Typography>
                                *To review your industry sectors/ job titles/
                                skills{" "}
                                <span
                                  style={{
                                    color: "#1155cc",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }}
                                  onClick={handleATSSettings}
                                >
                                  Click Here
                                </span>
                              </Typography>
                            </div>
                            <div
                              style={{ display: "flex", marginRight: "8px" }}
                            >
                              <Typography>
                                *To add Hiring Partners{" "}
                                <span
                                  style={{
                                    color: "#1155cc",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }}
                                  onClick={handleAddHiringPartner}
                                >
                                  Click Here
                                </span>
                              </Typography>
                            </div>
                            {toggle === false && (
                              <>
                                {isGroupOrgFlowTrue ? (
                                  <div style={{ display: "flex" }}>
                                    <Typography>
                                      *To add a Group Org{" "}
                                      <span
                                        style={{
                                          color: "#1155cc",
                                          cursor: "pointer",
                                          textDecoration: "underline",
                                        }}
                                        onClick={handleAddGrp}
                                      >
                                        Click Here
                                      </span>
                                    </Typography>
                                  </div>
                                ) : (
                                  <div style={{ display: "flex" }}>
                                    <Typography>
                                      *To add a Client{" "}
                                      <span
                                        style={{
                                          color: "#1155cc",
                                          cursor: "pointer",
                                          textDecoration: "underline",
                                        }}
                                        onClick={handleAddClient}
                                      >
                                        Click Here
                                      </span>
                                    </Typography>
                                  </div>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </div>

                      <div>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                onChange={handleToggle}
                                checked={toggle}
                                disabled={["Edit", "Preview"].includes(
                                  jobPostFormMode,
                                )}
                              />
                            }
                            label="is internal job"
                          />
                        </FormGroup>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}

            <Card elevation={0} sx={{ border: "2px solid #e0e0e0" }}>
              <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
                <Grid container>
                  {!toggle && ( 
                    <Grid item xs={12} md={4} sx={{ p: 1 }}>
                      <>
                        {isGroupOrgFlowTrue ? (
                          <SelectableSearch
                            isOptionEqualToValue={(option, value) =>
                              +option.ats_grouporg_id === +value.ats_grouporg_id
                            }
                            disabled={jobPostFormMode === "Preview"}
                            customBackground
                            label="Group Org"
                            value={jobPostData?.ats_grouporg_id}
                            loading={() =>
                              setAtsGroupUser({
                                load: false,
                                values: atsGroupCompanyData,
                              })
                            }
                            fieldLabel="name"
                            required
                            variant={"contained"}
                            name="ats_grouporg_id"
                            size="small"
                            data={atsgroupUser}
                            onChangeEvent={handleChange}
                            {...(errors.ats_grouporg_id && {
                              error: true,
                              helperText: errors.ats_grouporg_id,
                            })}
                          />
                        ) : (
                          <SelectableSearch
                            isOptionEqualToValue={(option, value) =>
                              +option.ats_company_id === +value.ats_company_id
                            }
                            disabled={jobPostFormMode === "Preview"}
                            customBackground
                            label="Client"
                            value={jobPostData?.ats_company_id}
                            loading={() =>
                              setCompanyData({
                                load: false,
                                values: atsCompanyData,
                              })
                            }
                            fieldLabel="company"
                            required
                            variant={"contained"}
                            name="ats_company_id"
                            size="small"
                            data={companyData}
                            onChangeEvent={handleChange}
                            {...(errors.ats_company_id && {
                              error: true,
                              helperText: errors.ats_company_id,
                            })}
                          />
                        )}
                      </>
                  </Grid>)}
                  <Grid item xs={12} md={4} sx={{ p: 1 }}>
                    {userData?.user_type === "Consultancy" ? (
                      <CustomTextField
                        disabled={true}
                        name="consultancy_id"
                        label="Hiring Partner"
                        size="small"
                        fullWidth
                        variant="outlined"
                        value={atsConsultancyData?.[0]?.consultancy}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    ) : (
                      <SelectableSearch
                        isOptionEqualToValue={(option, value) =>
                          +option.consultancy_id === +value.consultancy_id
                        }
                        disabled={jobPostFormMode === "Preview"}
                        customBackground
                        label="Hiring Partner"
                        value={jobPostData?.consultancy_id}
                        loading={() =>
                          setConsultancyData({
                            load: false,
                            values: atsConsultancyData,
                          })
                        }
                        fieldLabel="consultancy"
                        required={false}
                        multiple={true}
                        variant={"contained"}
                        name="consultancy_id"
                        size="small"
                        data={consultancyData}
                        onChangeEvent={handleChange}
                        {...(errors.consultancy_id && {
                          error: true,
                          helperText: errors.consultancy_id,
                        })}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} md={4} sx={{ p: 1 }}>
                    <SelectableSearch
                      isOptionEqualToValue={(option, value) =>
                        +option.recruiter_id === +value.recruiter_id
                      }
                      disabled={jobPostFormMode === "Preview"}
                      required={true}
                      label="Primary Recruiter"
                      noOptionText="Please select client to choose recruiter"
                      value={jobPostData?.primary_recruiter_id}
                      loading={() => handlePrimaryRecruiterLoading()}
                      fieldLabel="recruiter"
                      variant={"contained"}
                      name="primary_recruiter_id"
                      size="small"
                      data={primaryRecruiterData}
                      onChangeEvent={handleChange}
                      {...(errors.primary_recruiter_id && {
                        error: true,
                        helperText: errors.primary_recruiter_id,
                      })}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          sx={{
                            "& > img": { mr: 2, flexShrink: 0 },
                          }}
                          {...props}
                        >
                          {option?.recruiter} -{" "}
                          {option?.comcons_name
                            ? option?.comcons_name
                            : option?.user_type}
                        </Box>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} sx={{ p: 1 }}>
                    <SelectableSearch
                      isOptionEqualToValue={(option, value) =>
                        +option.recruiter_id === +value.recruiter_id
                      }
                      disabled={jobPostFormMode === "Preview"}
                      required={true}
                      label="Recruitment Manager"
                      noOptionText="Please select primary recruiter to choose recruitment manager"
                      value={jobPostData?.recruitment_manager_id}
                      loading={() => handleRecruiterManagerLoading()}
                      fieldLabel="recruiter"
                      variant={"contained"}
                      name="recruitment_manager_id"
                      size="small"
                      data={recruiterManagerData}
                      onChangeEvent={handleChange}
                      {...(errors.recruitment_manager_id && {
                        error: true,
                        helperText: errors.recruitment_manager_id,
                      })}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          sx={{
                            "& > img": { mr: 2, flexShrink: 0 },
                          }}
                          {...props}
                        >
                          {option?.recruiter} -{" "}
                          {option?.comcons_name
                            ? option?.comcons_name
                            : option?.user_type}
                        </Box>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} sx={{ p: 1 }}>
                    <CreatableSearch
                      isOptionEqualToValue={(option, value) =>
                        +option.industry_name === +value.industry_name
                      }
                      disabled={jobPostFormMode === "Preview"}
                      label="Industry Sector"
                      value={jobPostData?.industry_type}
                      fieldLabel="industry_name"
                      loading={() => handleIndustryTypeLoading()}
                      required={true}
                      variant={"contained"}
                      noOptionText="Start typing to add or select industry"
                      name="industry_type"
                      size="small"
                      data={industrytype}
                      onChangeEvent={handleChange}
                      {...(errors.industry_type && {
                        error: true,
                        helperText: errors.industry_type,
                      })}
                    />
                  </Grid>
                  {/* MPR */}
                  <Grid item xs={12} md={4} sx={{ p: 1 }}>
                    <SelectableSearch
                      isOptionEqualToValue={(option, value) =>
                        +option.mpr_id === +value.mpr_id
                      }
                      disabled={jobPostFormMode === "Preview"}
                      customBackground
                      label="MPR"
                      required={false}
                      value={
                        jobPostData?.mpr_id
                          ? {
                              ...jobPostData.mpr_id,
                              mpr_display:
                                jobPostData.mpr_id?.mpr_display ||
                                (jobPostData.mpr_id?.hiring_type
                                  ? `${jobPostData.mpr_id.mpr_no} - ${jobPostData.mpr_id.hiring_type}`
                                  : jobPostData.mpr_id.mpr_no),
                            }
                          : null
                      }
                      loading={() => handleMPROption()}
                      fieldLabel="mpr_display"
                      variant={"contained"}
                      name="mpr_id"
                      size="small"
                      data={mprData}
                      onChangeEvent={handleChange}
                      endIcon={
                        <Tooltip
                          title="Selecting an MPR will automatically fill the Department, Number of vacancies, Job Location and Job Description from the selected hiring request."
                          arrow
                        >
                          <InfoOutlinedIcon
                            sx={{
                              fontSize: 18,
                              cursor: "pointer",
                              color: "text.secondary",
                              mr: 1,
                            }}
                          />
                        </Tooltip>
                      }
                      optionsTooltipKeys={[
                        { key: "role", prefix: "Designation: " },
                        { key: "is_budgeted", prefix: "Is Budgeted: " },
                        { key: "max_salary", prefix: "Max Salary: " },
                      ]}
                      {...(errors.mpr_id && {
                        error: true,
                        helperText: errors.mpr_id,
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} sx={{ p: 1 }}>
                    <SelectableSearch
                      isOptionEqualToValue={(option, value) =>
                        +option.businessunit_id === +value.businessunit_id
                      }
                      disabled={jobPostFormMode === "Preview"}
                      customBackground
                      label="Department"
                      value={jobPostData?.businessunit_fk}
                      loading={() => handleBuload()}
                      fieldLabel="name"
                      name="businessunit_fk"
                      size="small"
                      onChangeEvent={handleChange}
                      data={buOption}
                      {...(errors?.businessunit_fk && {
                        error: true,
                        helperText: errors?.businessunit_fk,
                      })}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </>
        );

      case 1:
        return (
          <Card elevation={0} sx={{ border: "2px solid #e0e0e0", mt: 1 }}>
            <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
              <Grid container>
                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                    <CreatableSearch
                      isOptionEqualToValue={(option, value) =>
                        +option.job_template_id === +value.job_template_id
                      }
                      disabled={jobPostFormMode === "Preview"}
                      customBackground
                      label="Job Title"
                      value={jobPostData?.title}
                      noOptionText="Please select Industry Sector to choose title"
                      fieldLabel="job_title"
                      loading={() => handleJobTemplateLoading()}
                      onBlur={() => setJobTitle({ load: false, values: [] })}
                      required={true}
                      variant={"contained"}
                      name="title"
                      size="small"
                      data={jobTitle}
                      onChangeEvent={handleChange}
                      {...(errors.title && {
                        error: true,
                        helperText: errors.title,
                      })}
                    />
                </Grid>
                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                  <CreatableSearch
                    isOptionEqualToValue={(option, value) =>
                      option.skill === value.skill
                    }
                    disabled={jobPostFormMode === "Preview"}
                    customBackground
                    label="Primary Skills Required"
                    value={jobPostData?.primary_skill}
                    fieldLabel="skill"
                    loading={() =>
                      jobPostData?.industry_type?.industry_type_id
                        ? handleSkillsLoading()
                        : setSkills({ load: false, values: [] })
                    }
                    required={true}
                    limitTags={2}
                    noOptionText="Please select Industry Sector to choose skills"
                    variant={"contained"}
                    name="primary_skill"
                    size="small"
                    optionLabel="skill"
                    multiple={true}
                    data={skills}
                    onChangeEvent={handleChange}
                    {...(errors.primary_skill && {
                      error: true,
                      helperText: errors.primary_skill,
                    })}
                  />
                </Grid>
                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                  <CreatableSearch
                    isOptionEqualToValue={(option, value) =>
                      option.skill === value.skill
                    }
                    disabled={jobPostFormMode === "Preview"}
                    customBackground
                    label="Secondary Skills Required"
                    value={jobPostData?.secondary_skill}
                    fieldLabel="skill"
                    limitTags={2}
                    noOptionText="Please select Industry Sector to choose skills"
                    optionLabel="skill"
                    multiple={true}
                    loading={() =>
                      jobPostData?.industry_type?.industry_type_id
                        ? handleSkillsLoading2()
                        : setSkills2({
                            load: false,
                            values: [],
                          })
                    }
                    variant={"contained"}
                    name="secondary_skill"
                    size="small"
                    data={skills2}
                    onChangeEvent={handleChange}
                    {...(errors.secondary_skill && {
                      error: true,
                      helperText: errors.secondary_skill,
                    })}
                  />
                </Grid>
                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                  <CustomTextField
                    disabled={jobPostFormMode === "Preview"}
                    name="vaccancies"
                    label="Number of vacancies"
                    size="small"
                    type="number"
                    onKeyPress={(e) =>
                      e.target.value?.length > 4 && e.preventDefault()
                    }
                    onPaste={(e) =>
                      e.target.value?.length > 4 && e.preventDefault()
                    }
                    required={true}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    value={jobPostData.vaccancies}
                    {...(errors.vaccancies && {
                      error: true,
                      helperText: errors.vaccancies,
                    })}
                  />
                </Grid>
                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                  <CustomTextField
                    disabled={jobPostFormMode === "Preview"}
                    name="job_location"
                    label="Job Location"
                    size="small"
                    required={true}
                    onChange={handleChange}
                    onKeyPress={(e) =>
                      e.target.value?.length > 100 && e.preventDefault()
                    }
                    onPaste={(e) =>
                      e.target.value?.length > 100 && e.preventDefault()
                    }
                    fullWidth
                    variant="outlined"
                    value={jobPostData.job_location}
                    {...(errors?.job_location && {
                      error: true,
                      helperText: errors?.job_location,
                    })}
                  />
                </Grid>
                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                 <FormControl fullWidth>
                  <CustomTextField
                    disabled={jobPostFormMode === "Preview"}
                    name="designation"
                    label="Designation"
                    size="small"
                    onChange={handleChange}
                    onKeyPress={(e) =>
                      e.target.value?.length > 100 && e.preventDefault()
                    }
                    onPaste={(e) =>
                      e.target.value?.length > 100 && e.preventDefault()
                    }
                    fullWidth
                    variant="outlined"
                    value={jobPostData.designation}
                    {...(errors?.designation && {
                      error: true,
                      helperText: errors?.designation,
                    })}
                  />
                 </FormControl>
                </Grid>
                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                  <CreatableSearch
                    isOptionEqualToValue={(option, value) =>
                      +option.template_id === +value.template_id
                    }
                    disabled={jobPostFormMode === "Preview"}
                    customBackground
                    label="Feedback Template"
                    infoTooltip="Template used for evaluating candidates during interviews"
                    name="feedback_template_id"
                    value={jobPostData?.feedback_template_id}
                    loading={() => handleFeedBackTemplateLoading()}
                    fieldLabel="template_name"
                    variant={"contained"}
                    size="small"
                    data={feedbackTemplate}
                    onChangeEvent={handleChange}
                    {...(errors.feedback_template_id && {
                      error: true,
                      helperText: errors.feedback_template_id,
                    })}
                  />
                </Grid>
                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                  <CustomTextField
                    disabled={jobPostFormMode === "Preview"}
                    name="min_exp_required"
                    label="Minimum Experience"
                    size="small"
                    type="number"
                    onKeyPress={(e) =>
                      e.target.value?.length > 2 && e.preventDefault()
                    }
                    onPaste={(e) =>
                      e.target.value?.length > 2 && e.preventDefault()
                    }
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    value={jobPostData.min_exp_required}
                    {...(errors.min_exp_required && {
                      error: true,
                      helperText: errors.min_exp_required,
                    })}
                  />
                </Grid>
                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                  <CustomTextField
                    disabled={jobPostFormMode === "Preview"}
                    name="max_exp_required"
                    label="Maximum Experience"
                    size="small"
                    type="number"
                    onChange={handleChange}
                    onKeyPress={(e) =>
                      e.target.value?.length > 2 && e.preventDefault()
                    }
                    onPaste={(e) =>
                      e.target.value?.length > 2 && e.preventDefault()
                    }
                    fullWidth
                    variant="outlined"
                    value={jobPostData.max_exp_required}
                  />
                </Grid>
                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                  <CustomTextField
                    disabled={jobPostFormMode === "Preview"}
                    name="min_salary"
                    label="Minimum Salary"
                    size="small"
                    type="number"
                    required
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    onKeyPress={(e) =>
                      e.target.value?.length > 10 && e.preventDefault()
                    }
                    onPaste={(e) =>
                      e.target.value?.length > 10 && e.preventDefault()
                    }
                    value={jobPostData.min_salary}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip title="Minimum CTC to hire">
                            <InfoOutlinedIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                    {...(errors.min_salary && {
                      error: true,
                      helperText: errors.min_salary,
                    })}
                  />
                </Grid>
                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                  <CustomTextField
                    required={jobPostData?.offer_letter && (!jobPostData?.mpr_id || !jobPostData?.mpr_id?.is_budgeted)} // when mpr is not mapped/ non budgeted then Offer/CTC approval check job max salary
                    disabled={jobPostFormMode === "Preview"}
                    name="max_salary"
                    label="Maximum Salary"
                    size="small"
                    type="number"
                    onKeyPress={(e) =>
                      e.target.value?.length > 10 && e.preventDefault()
                    }
                    onPaste={(e) =>
                      e.target.value?.length > 10 && e.preventDefault()
                    }
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    value={jobPostData?.max_salary}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip title="Maximum CTC to hire">
                            <InfoOutlinedIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                    {...(errors.max_salary && {
                      error: true,
                      helperText: errors.max_salary,
                    })}
                  />
                </Grid>
                {!isAIJob && (
                  <Grid item xs={12} md={4} sx={{ p: 1 }}>
                    <CreatableSearch
                      isOptionEqualToValue={(option, value) =>
                        +option.prescreen_template_id ===
                        +value.prescreen_template_id
                      }
                      disabled={jobPostFormMode === "Preview"}
                      customBackground
                      label="Pre-Screen Assessment Template"
                      infoTooltip="Template used for initial candidate screening questionnaire / assessment"
                      name="prescreen_template_id"
                      value={jobPostData?.prescreen_template_id}
                      loading={() => handlepreScreenTemplateLoading()}
                      fieldLabel="prescreen_template_name"
                      variant={"contained"}
                      size="small"
                      data={prescreenTemplate}
                      onChangeEvent={handleChange}
                      {...(errors.prescreen_template_id && {
                        error: true,
                        helperText: errors.prescreen_template_id,
                      })}
                    />
                  </Grid>
                )}
                <Grid item xs={12} md={4} sx={{ p: 1, pl: 2 }}>
                  <FormControl disabled={jobPostFormMode === "Preview"}>
                    <FormLabel
                      id="demo-row-radio-buttons-group-label"
                      className={classes.labelText2}
                    >
                      Do you wish to make this job public?
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="make_public"
                      onChange={handleChange}
                      value={jobPostData?.make_public}
                      sx={{ mt: -1, height: "32px" }}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio size="small" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio size="small" />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              <Grid
                container
                item
                xs={12}
                alignItems="center"
                sx={{
                  ...(jobPostData?.offer_letter && {
                    border: "1px solid #e0e0e0",
                    borderRadius: "5px",
                    pt: "2px",
                    mb: 1,
                    mx: 1,
                    pl: -1.5
                  }),
                  ...(!jobPostData?.offer_letter && {
                    pl: 1.5
                  }),
                }}
              >
                <Grid
                  item
                  xs={12}
                  md={3}
                  sx={{
                    p: 1,
                    display: "flex",
                    alignItems: "center",
                    pl: 1,
                  }}
                >
                  <FormControl
                    disabled={jobPostFormMode === "Preview" || offerstatus}
                  >
                    <FormLabel
                      id="demo-row-radio-buttons-group-label"
                      className={classes.labelText2}
                    >
                      Include offer letter work flow?
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="offer_letter"
                      onChange={handleChange}
                      value={jobPostData?.offer_letter}
                      sx={{ mt: -1, height: "32px" }}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio size="small" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio size="small" />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                {jobPostData?.offer_letter && (
                  <Grid item xs={12} md={3} sx={{ p: 1 }}>
                    <SelectableSearch
                      required
                      isOptionEqualToValue={(option, value) =>
                        +option.offer_letter_template_id ===
                        +value.offer_letter_template_id
                      }
                      disabled={jobPostFormMode === "Preview" || offerstatus}
                      customBackground
                      label="Offer Letter Template"
                      name="offer_letter_template_id"
                      value={jobPostData?.offer_letter_template_id}
                      loading={() => handleOfferTemplateLoading()}
                      fieldLabel="offer_letter_template_name"
                      variant={"contained"}
                      size="small"
                      data={offerTemplate}
                      onChangeEvent={handleChange}
                      optionsTooltipKeys={[
                        { key: "template_type", prefix: "Type: " },
                        { key: "ctc_status", prefix: "CTC: " },
                      ]}
                      {...(errors.offer_letter_template_id && {
                        error: true,
                        helperText: errors.offer_letter_template_id,
                      })}
                    />
                  </Grid> 
                  )}
                  {jobPostData?.offer_letter && (
                  <>
                    <Grid item xs={12} md={3} sx={{ p: 1 }}>
                      <SelectableSearch
                        isOptionEqualToValue={(option, value) =>
                          +option.ats_users_id === +value.ats_users_id
                        }
                        disabled={jobPostFormMode === "Preview"}
                        required={jobPostData?.offer_letter}
                        label="Primary Approver"
                        name="approver_ats_users_id"
                        value={jobPostData?.approver_ats_users_id}
                        loading={() => handleApproverList("approver")}
                        fieldLabel="name"
                        variant={"contained"}
                        size="small"
                        data={approverListData}
                        onChangeEvent={handleChange}
                        {...(errors.approver_ats_users_id && {
                          error: true,
                          helperText: errors.approver_ats_users_id,
                        })}
                        endIcon={
                          <Tooltip title="Primary approver for this job. Approval is required when Offer Letter Flow is enabled. The candidate's CTC is compared against the MPR's max salary if the MPR is budgeted; otherwise, the Job's Max Salary is used. If neither limit is available, secondary approval is not required. Cannot be changed once the offer is generated." placement="top" arrow> 
                              <InfoOutlinedIcon sx={{ fontSize: 18, cursor: "pointer", color: "text.secondary"}}/>
                          </Tooltip>
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={3} sx={{ p: 1 }}>
                      <SelectableSearch
                        isOptionEqualToValue={(option, value) =>
                          +option.ats_users_id === +value.ats_users_id
                        }
                        required={jobPostData?.offer_letter}
                        disabled={jobPostFormMode === "Preview"}
                        label="Secondary Approver"
                        name="second_approver_ats_users_id"
                        value={jobPostData?.second_approver_ats_users_id}
                        loading={() => handleApproverList("second_approver")}
                        fieldLabel="name"
                        variant={"contained"}
                        size="small"
                        data={approverListData}
                        onChangeEvent={handleChange}
                        {...(errors.second_approver_ats_users_id && {
                          error: true,
                          helperText: errors.second_approver_ats_users_id,
                        })}
                        endIcon={
                          <Tooltip title="Secondary approver for this job. Required after Primary Approval if the candidate's CTC exceeds the applicable max limit (MPR's max salary for budgeted MPRs, or Job's Max Salary otherwise). If no applicable maximum limit is available, secondary approval is not required. Cannot be changed once the offer is generated." placement="top" arrow>
                            <InfoOutlinedIcon sx={{ fontSize: 18, cursor: "pointer", color: "text.secondary"}}/>
                          </Tooltip>
                        }
                      />
                    </Grid>
                  </>
                  )}
                </Grid>

              </Grid>
              </CardContent>
            </Card>
        );
      case 2:
        return (
          <Card elevation={0} sx={{ border: "2px solid #e0e0e0", mt: 1 }}>
            <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  md={12}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "space-between",
                    p: 2,
                    minHeight: "300px",
                  }}
                >
                  <>
                    <Grid item xs={6} md={6}>
                      <Typography className={classes.labelText}>
                        Job Description
                      </Typography>
                      <Quill
                        name="description"
                        value={description}
                        setValue={(val) => {
                          setDescription(val);
                          setErrors((prev) => {
                            return { ...prev, description: "" };
                          });
                        }}
                        error={Boolean(errors.description)}
                        style={{
                          height: "250px",
                          backgroundColor: "#ffffff",
                        }}
                      />
                      {errors?.description && (
                        <Typography
                          sx={{
                            color: "red",
                            paddingLeft: "20px",
                            paddingTop: 1,
                          }}
                        >
                          {errors?.description}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item xs={6} md={6} marginLeft={2}>
                      <Typography className={classes.labelText}>
                        Roles and Responsibilities
                      </Typography>
                      <Quill
                        name="roles_responsibilities"
                        value={rolesresponsibilities}
                        setValue={(val) => {
                          setRolesResponsibilities(val);
                          setErrors((prev) => {
                            return { ...prev, roles_responsibilities: "" };
                          });
                        }}
                        style={{
                          height: "250px",
                          backgroundColor: "#ffffff",
                        }}
                      />
                      {errors?.roles_responsibilities && (
                        <Typography
                          sx={{
                            color: "red",
                            paddingLeft: "20px",
                            paddingTop: 1,
                          }}
                        >
                          {errors?.roles_responsibilities}
                        </Typography>
                      )}
                    </Grid>
                  </>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        );
      case 3:
        return (
          <Card
            elevation={0}
            sx={{ border: "2px solid #e0e0e0", mt: 1, background: "#fff" }}
          >
            <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
              {/* TABS HEADER */}
              <Tabs
                value={step2Tab}
                onChange={(e, val) => setStep2Tab(val)}
                sx={{
                  minHeight: 32,
                  height: 32,
                  mb: 1,
                  "& .MuiTab-root": {
                    minHeight: 32,
                    height: 32,
                    padding: "0 12px",
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "0.85rem",
                  },
                }}
              >
                <Tab label="Pre-Screen Questions" />
                <Tab label="Video Questions" />
              </Tabs>

              {/* TAB BODY */}
              <Grid container>
                {/* TAB 0 → PRESCREEN */}
                {step2Tab === 0 && (
                  <PreScreenQuestionBuilder
                    questions={preScreenQuestions}
                    setQuestions={setPreScreenQuestions}
                    jobPostData={jobPostData}
                    setPostJobData={setPostJobData}
                    handlepreScreenTemplateLoading={
                      handlepreScreenTemplateLoading
                    }
                    prescreenTemplate={prescreenTemplate}
                    handleChange={handleChange}
                    errors={errors}
                    rolesresponsibilities={rolesresponsibilities}
                    description={description}
                    prebuilderTitle={prebuilderTitle}
                    setPreBuilderTitle={setPreBuilderTitle}
                    handleSaveNewPreScreenTemplate={
                      handleSaveNewPreScreenTemplate
                    }
                  />
                )}

                {/* TAB 1 → VIDEO QUESTIONS */}
                {step2Tab === 1 && (
                  <VideoQuestionBuilder
                    videoQuestions={videoQuestions}
                    setVideoQuestions={setVideoQuestions}
                    jobPostData={jobPostData}
                    setPostJobData={setPostJobData}
                    rolesresponsibilities={rolesresponsibilities}
                    description={description}
                  />
                )}
              </Grid>
            </CardContent>
          </Card>
        );

      case 4:
        return (
          <Card elevation={0} sx={{ border: "2px solid #e0e0e0", mt: 1 }}>
            <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
              <JobReview
                jobPostData={jobPostData}
                description={description}
                rolesresponsibilities={rolesresponsibilities}
                videoQuestions={videoQuestions}
                preScreenQuestions={preScreenQuestions}
                toggle={toggle}
                isGroupOrgFlowTrue={isGroupOrgFlowTrue}
              />
            </CardContent>
          </Card>
        );
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        maxHeight: "calc(100vh - 75px)",
        overflowY: "auto",
        pb: 2,
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 1,
          backgroundColor: "#ffffff",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 1,
          }}
        >
          <ArrowBackButton onClick={handleClose} iconSize={18} />

          <Typography fontWeight={700} color={"inherit"} fontSize={18}>
            {jobPostFormMode === "Preview"
              ? "Preview Job"
              : jobPostFormMode === "Edit"
                ? "Update Job"
                : "Create New Job"}
          </Typography>

          <Box>
            {isAIJob && (
              <Chip
                icon={<AutoAwesomeIcon />}
                label="AI POWERED"
                size="small"
                className={"ai-mpl-btn"}
                sx={{"& .MuiChip-icon": {
                  color: "white",
                  },
                }}
              />
            )}
          </Box>
        </Box>

        {/* STEPPER */}
        <Box sx={{ px: 2 }}>
          <Stepper activeStep={currentStep} alternativeLabel>
            {steps.map((step, index) => (
              <Step key={step} completed={index < currentStep}>
                <StepLabel
                  StepIconComponent={ColorStepIcon}
                  sx={{
                    "& .MuiStepLabel-label": {
                      marginTop: "4px",
                    },
                  }}
                >
                  {step}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      </Box>

      {/* FORM BODY */}
      <Paper sx={{ borderRadius: "10px", px: 2, py: 0.5 }}>
        {renderStepContent()}
      </Paper>

      {/* FOOTER NAV */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          p: 2,
        }}
      >
        <Button
          variant="contained"
          size="small"
          className="mpl-primary-btn"
          disabled={currentStep === 0}
          onClick={handleBack}
        >
          Back
        </Button>

        <Button
          variant="contained"
          size="small"
          className="mpl-primary-btn"
          onClick={handleNext}
        >
          {currentStep === steps.length - 1 ? "Save Job" : "Next"}
        </Button>
      </Box>
    </Box>
  );
};

const getStepFields = (isAIJob, jobPostData) => {
  if (isAIJob) {
    return {
      0: [
        "ats_company_id",
        "ats_grouporg_id",
        "consultancy_id",
        "primary_recruiter_id",
        "recruitment_manager_id",
        "industry_type",
      ],
      1: [
        "title",
        "primary_skill",
        "vaccancies",
        "job_location",
        "feedback_template_id",
        "min_salary",
        ...(jobPostData?.offer_letter && (!jobPostData?.mpr_id || !jobPostData?.mpr_id?.is_budgeted) ? ["max_salary"] : []),
        "offer_letter",
        "offer_letter_template_id",
        "approver_ats_users_id",
        "second_approver_ats_users_id",
      ],
      2: ["description", "roles_responsibilities"],
      3: ["prescreen_template_id"],
    };
  }

  // NON AI FLOW (no candidate screening step)
  return {
    0: [
      "ats_company_id",
      "ats_grouporg_id",
      "consultancy_id",
      "primary_recruiter_id",
      "recruitment_manager_id",
      "industry_type",
    ],
    1: [
      "title",
      "primary_skill",
      "vaccancies",
      "job_location",
      "feedback_template_id",
      "min_salary",
      ...(jobPostData?.offer_letter && (!jobPostData?.mpr_id || !jobPostData?.mpr_id?.is_budgeted)? ["max_salary"] : []),
      "offer_letter",
      "offer_letter_template_id",
      "approver_ats_users_id",
      "second_approver_ats_users_id",
    ],
    2: ["description", "roles_responsibilities"],
  };
};
const useStyles = makeStyles(() =>
  createStyles({
    mainContainer: {
      overflowY: "auto",
      height: "calc(100vh - 75px)",
      position: "relative",
      paddingBottom: "8px",
    },
    PaperContainer: {
      borderRadius: "10px",
      p: 1.5,
      overflowY: "auto",
      backgroundColor: "transparent",
      boxShadow: "none",
    },
    paper: {
      borderRadius: "10px",
      padding: "16px",
      overflowY: "auto",
    },
    headerContainer: {
      marginBottom: "24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 12px 0 8px",
    },
    title: {
      fontSize: "1.5rem",
      fontWeight: 700,
      marginBottom: "4px",
      color: "inherit",
    },
    subtitle: {
      fontSize: "0.875rem",
      color: "#666",
    },
    previewCardParent: {
      marginRight: "8px",
      overflow: "hidden",
      borderRadius: "16px",
      border: "4px solid rgb(243,237,253)",
      backdropFilter: "blur(4px)",
      backgroundColor: "rgba(255, 255, 255, 0.85)",
      boxShadow: "0 8px 30px rgba(99, 102, 241, 0.15)",
      backgroundImage: `
        radial-gradient(circle at 20% 30%, rgba(179,136,235,0.12) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(244,143,177,0.12) 0%, transparent 50%),
        radial-gradient(circle at 50% 80%, rgba(135,206,235,0.1) 0%, transparent 50%)
      `,
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
    previewCard: {
      position: "relative",
      minHeight: "300px",
      maxHeight: "calc(100vh - 170px)",
      borderRadius: "16px",
      padding: "16px",
      overflowY: "auto",
    },
    fieldCard: {
      position: "relative",
      borderRadius: "16px",
      padding: "16px",
      overflow: "hidden",
      backdropFilter: "blur(4px)",
      backgroundColor: "rgba(255, 255, 255, 0.85)",
      boxShadow: "0 8px 30px rgba(99, 102, 241, 0.15)",
      border: "4px solid rgb(243,237,253)",
      backgroundImage: `
        radial-gradient(circle at 20% 30%, rgba(179,136,235,0.12) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(244,143,177,0.12) 0%, transparent 50%),
        radial-gradient(circle at 50% 80%, rgba(135,206,235,0.1) 0%, transparent 50%)
      `,
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
    previewHeader: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginBottom: "16px",
    },
    labelText: {
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: 1.6,
      color: "inherit",
    },
    labelText2: {
      fontSize: "0.9rem",
      fontWeight: 500,
      color: "inherit",
    },
    Backdrop: {
      zIndex: 1,
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      position: "absolute",
      borderRadius: "inherit",
    },
    htmlPreviewBox: {
      borderRadius: "8px",
      padding: "12px 16px",
      overflowY: "auto",
      maxHeight: "300px",
      border: "1px solid rgba(0,0,0,0.1)",
      marginTop: "4px",
    },
  }),
);

const ColorStepIcon = (props) => {
  const { active, completed, icon } = props;

  return (
    <Box
      sx={{
        width: 22,
        height: 22,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "black",
        fontWeight: "600",
        bgcolor: completed ? "" : active ? "primary.main" : "#ffffff",
      }}
    >
      {completed ? (
        <CheckCircle
          sx={{ width: 22, height: 22 }}
          fontSize="medium"
          color="primary"
        />
      ) : (
        icon
      )}{" "}
    </Box>
  );
};

export default CreateJobStepper;
